<div class="menu">
  <a (click)="toggleMenu()" class="menuButton">
    <img class="icons" src="./image/menu.png">
  </a>
  @if(isMenuActive) {
    <fluent-menu class="menu-content-left">
      <fluent-menu-item (click)="openDialog('info')">About</fluent-menu-item>
      <fluent-menu-item (click)="openDialog('settings')">Settings</fluent-menu-item>
      <fluent-divider />
      @if(isAuthenticated) {
        <fluent-menu-item (click)="logout()">Logout</fluent-menu-item>
      }
      <fluent-menu-item (click)="closeApp()">Quit</fluent-menu-item>
    </fluent-menu>
  }
</div>

@if(activeDialog === 'info') {
  <app-about-dialog (closed)="closeDialog()" />
}

@if(activeDialog === 'settings') {
  <app-settings-dialog (closed)="closeDialog()" />
}